import React from 'react';
import { useTranslation } from 'react-i18next';
import FormField from 'components/FormField';
import TextInput from 'components/TextInput';
import { jsx as _jsx } from "react/jsx-runtime";
var CustomDataField = function CustomDataField(_ref) {
  var customData = _ref.customData,
    onChange = _ref.onChange,
    isDisabled = _ref.isDisabled;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsx(FormField, {
    label: t('form_custom_data'),
    children: /*#__PURE__*/_jsx(TextInput, {
      value: customData,
      onChange: onChange,
      disabled: isDisabled
    })
  });
};
export default CustomDataField;